import { fetchApi } from '../../services/api';
import LoadingPanel from '../../components/LoadingPanel';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { useState } from 'react';
import dayjs from 'dayjs';
import { JsonResponse } from 'TypeGen/json-response';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';

type Props = {
  VehicleID: number;
  CloseDialog: (refresh: boolean) => void;
}

const AddOdometerReadingDialog = (props: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [odometer, setOdometer] = useState<number>();
  const [dateTime, setDateTime] = useState<Date | null>(dayjs.utc().toDate());

  const save = () => {
    if (odometer === 0 || dateTime === null)
    {
      alert('Please fill in all required fields');
      return;
    }

    setLoading(true);

    const data = {
      Odometer: odometer,
      DateTime: dateTime,
      DataSource: 0,
    }

    fetchApi(`/api/Asset/AddOdometerReading/${props.VehicleID}`, data, 'POST')
      .then((response: JsonResponse) => {
        if (response.Success)
        {
          props.CloseDialog(true);
        }
        else
        {
          setLoading(false);
          alert(response.ErrorMessage);
        }
      }).catch((e) => {
        setLoading(false);
        // If not problem details
        if (!e?.status) alert('Unable to save reading');
      });
  }

  return <Dialog title="Add Odometer Reading" onClose={() => props.CloseDialog(false)} className='dialog-w525'>
    {loading && <LoadingPanel />}
    <div className="row">
      <label className="col-md-4 col-form-label">Reading:</label>
      <div className="col-md-8">
        <NumericTextBox
          min={0}
          value={odometer}
          placeholder='Enter Odometer Reading In Miles'
          spinners={false}
          onChange={(e) => setOdometer(e.value)}
          style={{ width: "100%" }}
        />
      </div>
    </div>
    <div className="row pt-2">
      <label className="col-md-4 col-form-label">Reading On:</label>
      <div className="col-md-8">
        <DateTimePicker
          required
          value={dateTime}
          onChange={(e) => setDateTime(e.value)}
        />
      </div>
    </div>
    <DialogActionsBar layout="end">
      <Button onClick={() => props.CloseDialog(false)}>Cancel</Button>
      <Button
        themeColor="primary"
        disabled={loading}
        onClick={save}
      >
        Add Reading
      </Button>
    </DialogActionsBar>
  </Dialog>;
}

export default AddOdometerReadingDialog